exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3mh_P{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._1H1IZ{margin-bottom:15px!important}.oCs5n{padding:10px 35px 10px 10px}._3v7AQ,.oCs5n{height:40px;border-radius:2px;font-size:14px;border:1px solid #aaa;background-color:#fff;color:#484848;font-weight:400}._3v7AQ{padding:10px 32px 10px 10px}.Gm7La{position:relative;display:inline-block;vertical-align:bottom;margin-right:5px}._1SzKo{overflow:hidden}._3iHuh{max-width:350px}._3u6rI{padding:0}._1Z1q3,._205tT{margin-bottom:12px}._1AlwD{margin-bottom:18px}.iiouo{font-size:15px;color:#767676;margin:6px 0;line-height:1.43;font-weight:400}._3XdyU{margin-right:10px}.gWUxe{float:right}._25MQl{text-align:right}.Dv5LU{text-align:left}._1vkAA{color:#008489}._3_xLl{font-size:16px;line-height:32px}._1vkAA:focus,._1vkAA:hover{color:#008489;text-decoration:underline}._3MNYF{box-sizing:border-box;margin:0;width:auto;outline:0;border:1px solid #373277;border-radius:4px;background:#373277;color:#fff;text-align:center;text-decoration:none;font-size:16px;line-height:1.3333333;cursor:pointer}._3MNYF:hover{background:rgba(54,50,119,.8)}._3MNYF:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}.Xqslk{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}.Xqslk:disabled:focus,.Xqslk:disabled:hover,.Xqslk:focus,.Xqslk:hover{border-color:#ff7e82;background-color:#ff7e82;color:#fff}._36896{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._36896:focus,._36896:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}.cXWbb{padding:5px 0}._13lOf{padding:7px 21px}._2eSfP{position:relative;z-index:1;display:block;margin:15px 0;width:100%;color:#767676;text-align:center;font-size:14px}._1ETqV,._1H1IZ ._2jIv7,._2K_Jn{border:1px solid #aaa}._1ETqV{padding:15px;border-radius:2px}", ""]);

// exports
exports.locals = {
	"errorMessage": "_3mh_P",
	"formGroup": "_1H1IZ",
	"formControlInput": "oCs5n",
	"formControlSelect": "_3v7AQ",
	"select": "Gm7La",
	"formSection": "_1SzKo",
	"formMaxWidth": "_3iHuh",
	"noPadding": "_3u6rI",
	"space1": "_1Z1q3",
	"space2": "_205tT",
	"space3": "_1AlwD",
	"labelText": "iiouo",
	"btnRight": "_3XdyU",
	"btnAlignRight": "gWUxe",
	"textAlignRight": "_25MQl",
	"textAlignLeft": "Dv5LU",
	"modalCaptionLink": "_1vkAA",
	"modalCaptionLinkLarge": "_3_xLl",
	"button": "_3MNYF",
	"btnPrimary": "Xqslk",
	"btnPrimaryBorder": "_36896",
	"btnSmall": "cXWbb",
	"btnLarge": "_13lOf",
	"horizontalLineThrough": "_2eSfP",
	"input-group-addon": "_2jIv7",
	"inputGroupAddon": "_2K_Jn",
	"formContainer": "_1ETqV"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/PhoneVerificationModal/AddPhoneNumberForm/AddPhoneNumberForm.css
// module id = 2552
// module chunks = 15